export default __webpack_public_path__ + "static/media/mat5afesh.034eb12b.mp3";